/**
 * Copyright by INSIDE M2M GmbH and the authors 2004 - 2018
 *
 *************************************************************
 ********************* CONFIDENTIAL **************************
 *************************************************************
 *
 */

import { NgModule } from '@angular/core';

import { AlertifyService } from './alertify.service';

@NgModule({
    providers: [AlertifyService],
})
export class AlertifyModule {}
